<div class="layout-type__root" [class.phone]="isPhone" padding-top>
  <div *ngIf="!isPhone" class="layout-type__item-wrapper" [class.active]="listing.propertyLayout === 1" tappable
    (click)="selectPropertyLayout(1)">
    <div class="layout-type__item landscape">
      <div class="type type1__left" data-cy="propLayoutSel-layout-first-left"></div>
      <div class="type type1__right" data-cy="propLayoutSel-layout-first-right"></div>
      <div class="type type1__img" data-cy="propLayoutSel-layout-first-img"></div>
      <div class="type type1__text1" data-cy="propLayoutSel-layout-first-txt1"></div>
      <div class="type type1__text2" data-cy="propLayoutSel-layout-first-txt2"></div>
    </div>
  </div>
  <div *ngIf="!isPhone" class="layout-type__item-wrapper" [class.active]="listing.propertyLayout === 2" tappable
    (click)="selectPropertyLayout(2)">
    <div class="layout-type__item landscape">
      <div class="type type2__left" data-cy="propLayoutSel-layout-second-left"></div>
      <div class="type type2__right" data-cy="propLayoutSel-layout-second-right"></div>
      <div class="type type2__img" data-cy="propLayoutSel-layout-second-img"></div>
      <div class="type type2__text1" data-cy="propLayoutSel-layout-second-txt1"></div>
      <div class="type type2__text2" data-cy="propLayoutSel-layout-second-txt2"></div>
    </div>
  </div>
  <div class="layout-type__item-wrapper" [class.active]="listing.propertyLayout === 3" tappable
    (click)="selectPropertyLayout(3)">
    <div class="layout-type__item portrait">
      <div class="type type3__left" data-cy="propLayoutSel-layout-third-left"></div>
      <div class="type type3__right" data-cy="propLayoutSel-layout-third-right"></div>
      <div class="type type3__img" data-cy="propLayoutSel-layout-third-img"></div>
      <div class="type type3__text1" data-cy="propLayoutSel-layout-third-txt1"></div>
      <div class="type type3__text2" data-cy="propLayoutSel-layout-third-txt2"></div>
    </div>
  </div>
  <div class="layout-type__item-wrapper" [class.active]="listing.propertyLayout === 4" tappable
    (click)="selectPropertyLayout(4)">
    <div class="layout-type__item portrait">
      <div class="type type4__left" data-cy="propLayoutSel-layout-fourth-left"></div>
      <div class="type type4__right" data-cy="propLayoutSel-layout-fourth-right"></div>
      <div class="type type4__img" data-cy="propLayoutSel-layout-fourth-img"></div>
      <div class="type type4__text1" data-cy="propLayoutSel-layout-fourth-txt1"></div>
      <div class="type type4__text2" data-cy="propLayoutSel-layout-fourth-txt2"></div>
    </div>
  </div>
</div>